




















import { Cadastros } from "@/services/dashboard.service";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

import ChartBar from "@/shared/components/chart-bar.vue";
import { ticks, title } from "@/shared/utils/chart";

@Component({
  components: { ChartBar },
})
export default class GraficoColunasCadastrosMensais extends Vue {
  readonly options: Chart.ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,

    tooltips: {
      mode: "index",
      callbacks: {
        //Callback para montar o titulo do tooltip
        title: title(),
      },
    },
    scales: {
      yAxes: [
        {
          stacked: true,
          ticks: {
            precision: 0,
            beginAtZero: true,
          },
        },
      ],
      xAxes: [
        {
          stacked: true,
          ticks: {
            callback: ticks(),
          },
        },
      ],
    },
  };

  @Prop() readonly loading!: boolean;
  @Prop() readonly value!: Cadastros[];

  get labels() {
    return this.value.map((x) => x.data);
  }

  get dataSets(): Chart.ChartDataSets[] {
    return [
      {
        label: "App",
        backgroundColor: "#258D3F",
        data: this.value?.map((x) => x.quantidadeApp ?? 0),
      },
      {
        label: "Site",
        backgroundColor: "#A2E5B3",
        data: this.value?.map((x) => x.quantidadeSite ?? 0),
      },
      {
        label: "Média",
        data: this.obterMedia(),
        backgroundColor: "#CFCFCF99",
        type: "line",
        lineTension: 0,
      },
    ];
  }

  obterMedia() {
    const filter = this.value.filter(
      (item) => (item.quantidadeSite ?? 0 > 0) || (item.quantidadeApp ?? 0 > 0)
    );
    const media = +(filter ?? [])
      .map(
        (x) =>
          ((x.quantidadeSite ?? 0) + (x.quantidadeApp ?? 0)) / filter.length
      )
      .reduce((total, i) => total + i)
      .toFixed(2);
    return this.value?.map(() => media);
  }
}
